import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { RequestBuilderService } from '../../request-builder.service';
import { DocumentActorWithCheckboxes } from 'src/app/models/actors';
import { Subscription } from 'rxjs';
import { ExistsIn, SingleOrDefault } from 'src/app/_helpers/ArrayExtensionMethodHelper.functions';

@Component({
    selector: 'app-checklist',
    templateUrl: './checklist.component.html'
})
export class ChecklistComponent implements OnDestroy {
    @Input() action: string | null = null;
    @Input() useCheckboxes: boolean = false;
    @Output() selectedPersonIds = new EventEmitter<string[]>();
    public persons: DocumentActorWithCheckboxes[] = [];
    private personsWithAvailableAndBlockedActions: any[] = [];
    public selectedDossierPersonIds: string[] = [];
    private actorsSubscription: Subscription | null = null;
    private blockedActorActionsSubscription: Subscription | null = null;


    constructor(private requestBuilderService: RequestBuilderService) {
        this.actorsSubscription = this.requestBuilderService.persons$.subscribe(persons => {
            this.persons = persons;
            // somehow checked is retained when closing the popup. RESET it manually
            if (this.persons && this.persons.length > 0) {
                this.persons.forEach(resetPerson => resetPerson.checked = false);
            }
        });
        this.blockedActorActionsSubscription = this.requestBuilderService.validationSummary$.subscribe(validationSummary => {
            if (validationSummary?.actionValidationSummary?.persons) {
                this.personsWithAvailableAndBlockedActions = validationSummary.actionValidationSummary.persons;
            }
        })
    }

    ngOnDestroy(): void {
        if (this.actorsSubscription) {
            this.actorsSubscription.unsubscribe();
        }
        if (this.blockedActorActionsSubscription) {
            this.blockedActorActionsSubscription.unsubscribe();
        }
    }

    countActionsOfActor(actorId: string) {
        return this.requestBuilderService.getCountActionsOfActor(actorId);
    }

    toggle(dossierPersonId: string) {
        let actor = SingleOrDefault(this.persons, "dossierPersonId", dossierPersonId)
        if (actor && !actor.checked) {
            if (actor) {
                actor.checked = true;
            }
        } else {
            if (actor) {
                actor.checked = false;
            }
        }

        this.selectedPersonIds.emit(this.persons.filter(s => s.checked).map(d => d.dossierPersonId));
    }

    isSelected(dossierPersonId: string) {
        return ExistsIn(this.selectedDossierPersonIds, 0, dossierPersonId);
    }

    personIsDisabled(dossierPersonId: string) {
        let personsWithAvailableAndBlockedActionsIndex = this.personsWithAvailableAndBlockedActions.findIndex(s => s.personGuid === dossierPersonId);
        // pERSON WITHOUT ACTIONS? ENABLED
        if (personsWithAvailableAndBlockedActionsIndex < 0) {
            return false;
        }
        // CANNOT BE BLOCKED - ELSE DISABLED
        if (this.action && this.personsWithAvailableAndBlockedActions[personsWithAvailableAndBlockedActionsIndex].blockedActions.includes(this.action)) {
            return true;
        }
        // MUST BE POSSIBLE - ELSE DISABLED
        if (this.action && !this.personsWithAvailableAndBlockedActions[personsWithAvailableAndBlockedActionsIndex].possibleActions.includes(this.action)) {
            return true;
        }
        // DEFAULT ENABLED
        return false;
    }
}
